export enum ACTIVE_STEP {
  SUGGESTIONS = 'suggestions',
  OPPORTUNITIES = 'opportunities',
  ACTIVE_LANES = 'activeLanes',
  INACTIVE_LANES = 'inactiveLanes',
}
